<template>
  <PremiumMetricWidgetBase :widget="widget" v-slot="{ metric }" :state="state">
    <div class="chart-wrapper">
      <apexchart height="100%" width="100%" :options="chartOptions" :series="series(metric)" />
    </div>
  </PremiumMetricWidgetBase>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import PremiumMetricWidgetBase from './PremiumMetricWidgetBase.vue';
import { formatNumber } from '@/utils/formatNumbers';
import {
  getChartExportSettings,
  getDefaultChartOptions,
  type BaseChartOptions,
} from '@/utils/chartSettings';
import type { WidgetFilter, WidgetObject, WidgetSetting } from '@/types/Widget';

const props = defineProps<{
  widget: WidgetObject;
  area?: WidgetFilter;
  time?: WidgetFilter;
  zone?: WidgetSetting;
  cluster?: WidgetSetting;
  day?: WidgetSetting;
}>();

const defaultChartOptions = getDefaultChartOptions(props.widget.code_name);

const isDailyMode = computed(() => props.time?.name === 'Day');
const state = ref<string | null>(null);

const zoneQuantities = (metric: any) => {
  return Object.keys(metric.data.data['Site']['Total'] || {});
};

const series = (metric: any) => {
  try {
    if (isDailyMode.value && props.day?.id) {
      const dayId = props.day.id;
      return [
        {
          name: 'Zone Count Visited',
          data: zoneQuantities(metric).map((zoneQuantity: string) => ({
            x: zoneQuantity + ` ${parseInt(zoneQuantity) > 1 ? 'Zones' : 'Zone'}`,
            y: metric.data.data['Site']['Day'][dayId][zoneQuantity]['Engaged Percent'],
          })),
        },
      ];
    } else {
      return [
        {
          name: 'Zone Count Visited',
          data: zoneQuantities(metric).map((zoneQuantity: string) => ({
            x: zoneQuantity + ` ${parseInt(zoneQuantity) > 1 ? 'Zones' : 'Zone'}`,
            y: metric.data.data['Site']['Total'][zoneQuantity]['Engaged Percent'],
          })),
        },
      ];
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};

const chartOptions = computed<BaseChartOptions>(() => {
  const baseOptions: BaseChartOptions = {
    chart: {
      ...defaultChartOptions.value.chart,
      type: 'donut',
      toolbar: getChartExportSettings(
        props.widget.name,
        props.area?.name || '',
        props.time?.name || '',
        props.zone?.title || '',
        props.cluster?.title || '',
        props.day?.title || '',
      ),
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      ...defaultChartOptions.value.legend,
      horizontalAlign: 'center',
    },
    tooltip: {
      y: {
        formatter: (val: number) => {
          return formatNumber(100 * val, 2) + '%';
        },
      },
    },
  };
  return baseOptions;
});
</script>
